<template>
  <section class="wrapper download_page faq">
    <h1>{{ $t('faq.key009') }}</h1>
    <div class="block">
      <div class="faq-item" v-for="(faq, index) in faq_mobile" :key="'download_' + index" :ref="'download_' + index">
        <div class="faq-question" @click="toggleAnswer('download_' + index)" :style="{ color: faq.open ? 'white' : '#A6BED9' }">
          <i class="bi bi-caret-right-fill faq-icon" :class="{ open: faq.open }"></i>
          {{ faq.question }}
        </div>
        <div v-if="faq.open">
          <div class="beatday-2d" v-for="(step, stepIndex) in faq.steps" :key="'step_' + stepIndex">
            <div class="img" v-if="step.image">
              <img :src="step.image" alt="" />
            </div>
            <div class="content" :class="{ 'no-img': !step.image }">
              <h3 v-if="faq.steps.length > 1">step {{ stepIndex + 1 }}</h3>
              <p v-html="step.content"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import store from '@/vuex';

export default {
  name: 'FAQ',
  components: {},
  mounted() {},
  data() {
    const currentLanguage = store.state.currentLanguage;
    return {
      faq_mobile: [
        {
          question: this.$t('beatday-mobile.key001'),
          steps: [
            {
              // TODO 多語系圖檔更新後 連結中語系資料夾要使用${currentLanguage}
              image: `${this.$cloudFront}/Image/Public/faq/beatdayMobile/zh_tw/BeatdayMobile_1.jpg`,
              content: this.$t('beatday-mobile.key002').replace(/\n/g, '<br/><br/>'),
            },
          ],
          open: false,
        },
        {
          question: this.$t('beatday-mobile.key003'),
          steps: [
            {
              image: `${this.$cloudFront}/Image/Public/faq/liveStreaming/${currentLanguage}/Q001_001.jpg`,
              content: this.$t('beatday-mobile.key004'),
            },
          ],
          open: false,
        },
        {
          question: this.$t('beatday-mobile.key005'),
          steps: [
            {
              image: `${this.$cloudFront}/Image/Public/faq/liveStreaming/${currentLanguage}/Q002_001.jpg`,
              content: this.$t('beatday-mobile.key006'),
            },
          ],
          open: false,
        },
        {
          question: this.$t('beatday-mobile.key007'),
          steps: [
            {
              image: `${this.$cloudFront}/Image/Public/faq/liveStreaming/${currentLanguage}/Q003_001.jpg`,
              content: this.$t('beatday-mobile.key008'),
            },
          ],
          open: false,
        },
        {
          question: this.$t('beatday-mobile.key009'),
          steps: [
            {
              image: `${this.$cloudFront}/Image/Public/faq/liveStreaming/${currentLanguage}/Q004_001.jpg`,
              content: this.$t('beatday-mobile.key010'),
            },
          ],
          open: false,
        },
        {
          question: this.$t('beatday-mobile.key011'),
          steps: [
            {
              image: `${this.$cloudFront}/Image/Public/faq/liveStreaming/${currentLanguage}/Q005_001.jpg`,
              content: this.$t('beatday-mobile.key012'),
            },
            {
              image: `${this.$cloudFront}/Image/Public/faq/liveStreaming/${currentLanguage}/Q005_002.jpg`,
              content: this.$t('beatday-mobile.key019'),
            },
          ],
          open: false,
        },
        {
          question: this.$t('beatday-mobile.key013'),
          steps: [
            {
              content: this.$t('beatday-mobile.key014'),
            },
          ],
          open: false,
        },
        {
          question: this.$t('beatday-mobile.key015'),
          steps: [
            {
              content: this.$t('beatday-mobile.key016', {
                netSpeedTest: `<a href='https://fast.com/'>${this.$t('beatday-mobile.key017')}</a>`,
                LineLink: `<a href='https://line.me/R/ti/p/@485ibcgx?oat__id=29053'>${this.$t('beatday-mobile.key018')}</a>`,
              }).replace(/\n/g, '<br/>'),
            },
          ],
          open: false,
        },
      ],
    };
  },
  props: {},
  computed: {},
  methods: {
    toggleAnswer: function (key) {
      this.faq_mobile.forEach((faq, index) => {
        const faqKey = 'download_' + index;

        if (faqKey === key) {
          faq.open = !faq.open;

          if (faq.open) {
            this.$nextTick(() => {
              const targetElement = this.$refs[faqKey];

              if (targetElement) {
                const element = Array.isArray(targetElement) ? targetElement[0] : targetElement;

                const elementTop = element.getBoundingClientRect().top + window.pageYOffset;

                window.scrollTo({
                  top: elementTop - 150,
                  behavior: 'smooth',
                });
              }
            });
          }
        } else {
          faq.open = false;
        }
      });
    },
  },
};
</script>

<style lang="scss"></style>
